import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=d84799ca&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"
import style0 from "./carousel.vue?vue&type=style&index=0&id=d84799ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84799ca",
  null
  
)

export default component.exports